import { Component, ViewChild } from '@angular/core';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AssetService } from '../../Model/AssetModule/asset.service';
import { CommonModule } from '@angular/common';
import { RouterModule, RouterOutlet } from '@angular/router';
import { CommonService } from '../../Model/Common/common.service';
import { link } from 'fs';

@Component({
  selector: 'app-asset-master',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, DataTablesModule],
  templateUrl: './asset-master.component.html',
  styleUrl: './asset-master.component.scss'
})
export class AssetMasterComponent {
  isDisabled: boolean = false;
  TableDatas = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private Asset: AssetService,
    protected common: CommonService
  ) { 
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.LoadAssetMaster();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
  Link(Text: string) {
    return this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + 'AssetMasterAttachment' + '/' + Text;
  }

  LoadAssetMaster() {
    this.isDisabled = true;
    this.Asset.LoadAssetMaster({ SelectType: 1, ESS_AssetMasterID: 0 }).subscribe({
      next: (response) => {
        this.TableDatas = Object.values(response);
        this.Link(this.TableDatas.Image)
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

}
